import { useGetAllShows } from '~entities/recital-manager/api/get-all-shows';
import { VolunteerManagementTable } from '~entities/recital-manager/ui/VolunteerManagementTable';

import {
  Card,
  CardContent,
} from '~/shared/shadcn/ui/card';

interface VolunteersTabProps {
  recitalId: string;
}

export const VolunteersTab = ({ recitalId }: VolunteersTabProps) => {
  const { data: showsResponse } = useGetAllShows({ recitalId });
  const shows = showsResponse?.data || [];

  return (
    <div className='space-y-6'>      
      {/* Volunteer Management Table */}
      <Card>
        <CardContent className='p-6'>
          <VolunteerManagementTable 
            recitalId={recitalId} 
            shows={shows.map(show => ({ _id: show._id, name: show.name }))} 
          />
        </CardContent>
      </Card>
    </div>
  );
};
